import React from 'react';
import { 
  Clock, 
  ShieldCheck, 
  UserX, 
  ShieldAlert
} from 'lucide-react';

const TeacherStatus = ({ status }) => {
  // دالة جلب الإعدادات البصرية بناءً على الحالة (المنطق الأصلي مطور)
  const getStatusConfig = (status) => {
    switch (status) {
      case 'approved':
        return {
          icon: <ShieldCheck className="h-5 w-5" />,
          text: 'مدرس معتمد',
          bgColor: 'bg-emerald-50',
          borderColor: 'border-emerald-100',
          textColor: 'text-emerald-700',
          glow: 'shadow-emerald-100'
        };
      case 'pending':
        return {
          icon: <Clock className="h-5 w-5 animate-pulse" />,
          text: 'بانتظار مراجعة الإدارة',
          bgColor: 'bg-amber-50',
          borderColor: 'border-amber-100',
          textColor: 'text-amber-700',
          glow: 'shadow-amber-100'
        };
      case 'rejected':
        return {
          icon: <UserX className="h-5 w-5" />,
          text: 'تم رفض الطلب',
          bgColor: 'bg-rose-50',
          borderColor: 'border-rose-100',
          textColor: 'text-rose-700',
          glow: 'shadow-rose-100'
        };
      default:
        return {
          icon: <ShieldAlert className="h-5 w-5" />,
          text: 'حالة غير معرفة',
          bgColor: 'bg-gray-50',
          borderColor: 'border-gray-100',
          textColor: 'text-gray-500',
          glow: 'shadow-none'
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <div className={`
      inline-flex items-center gap-3 px-5 py-2.5 rounded-2xl border transition-all duration-300 shadow-sm
      ${config.bgColor} ${config.borderColor} ${config.glow}
    `}>
      {/* Icon Wrapper with subtle background */}
      <div className={`p-1.5 rounded-xl bg-white shadow-sm ${config.textColor}`}>
        {config.icon}
      </div>
      
      <div className="flex flex-col">
        <span className={`text-[10px] font-black uppercase tracking-[0.1em] opacity-60 leading-none mb-1`}>
            حالة الحساب
        </span>
        <span className={`text-sm font-black leading-none ${config.textColor}`}>
            {config.text}
        </span>
      </div>

      {/* Decorative Dot for approved status */}
      {status === 'approved' && (
          <div className="mr-2 flex h-2 w-2 relative">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
          </div>
      )}
    </div>
  );
};

export default TeacherStatus;